var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0725 9.7025C26.0434 7.04044 24.2567 4.73829 21.9334 3.08057C19.6102 1.42286 16.852 0.482251 14 0.375C11.1479 0.482251 8.38983 1.42286 6.06655 3.08057C3.74326 4.73829 1.95663 7.04044 0.927494 9.7025C0.85799 9.89474 0.85799 10.1053 0.927494 10.2975C1.95663 12.9596 3.74326 15.2617 6.06655 16.9194C8.38983 18.5771 11.1479 19.5177 14 19.625C16.852 19.5177 19.6102 18.5771 21.9334 16.9194C24.2567 15.2617 26.0434 12.9596 27.0725 10.2975C27.142 10.1053 27.142 9.89474 27.0725 9.7025ZM14 15.6875C12.8751 15.6875 11.7755 15.3539 10.8402 14.729C9.90488 14.104 9.1759 13.2158 8.74543 12.1765C8.31496 11.1373 8.20232 9.99369 8.42178 8.89042C8.64123 7.78716 9.18291 6.77374 9.97832 5.97833C10.7737 5.18292 11.7872 4.64124 12.8904 4.42178C13.9937 4.20233 15.1373 4.31496 16.1765 4.74544C17.2158 5.17591 18.104 5.90489 18.729 6.84019C19.3539 7.7755 19.6875 8.87512 19.6875 10C19.6852 11.5077 19.0852 12.953 18.0191 14.0191C16.953 15.0852 15.5077 15.6852 14 15.6875Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/view.e05e9e90649db50b565e6af3ab672f18.svg";